export const compaignData = [
  {
    name: "Distribution",
    type: "Public Relations",
    progress:
      "40.5% Opened\n \n  20.5% Closed\n \n  30.5% Unsubscribe\n \n  70.5% Delivered\n \n  35.0% Conversation",
    members: "3+",
    startDate: "25 Sep 2023",
    endDate: "29 Sep 2023",
    status: "Success",
    created: "25 Sep 2023",
    Action: "Edit      Delete",
    key: "1",
  },
  {
    name: "Merchandising",
    type: "Content Marketing",
    progress:
      "65.5% Opened\n \n  83.5% Closed\n \n  67.5% Unsubscribe\n \n  32.0% Delivered\n \n  22.5% Conversation",
    members: "3+",
    startDate: "03 Oct 2023",
    endDate: "16 Oct 2023",
    status: "Pending",
    created: "03 Oct 2023",
    Action: "Edit      Delete",
    key: "2",
  },
  {
    name: "Pricing",
    type: "Social Marketing",
    progress:
      "64.0% Opened\n \n  97.0% Closed\n \n  14.5% Unsubscribe\n \n  38.5% Delivered\n \n  53.0% Conversation",
    members: "3+",
    startDate: "17 Oct 2023",
    endDate: "28 Oct 2023",
    status: "Success",
    created: "17 Oct 2023",
    Action: "Edit      Delete",
    key: "3",
  },
  {
    name: "Increased sales",
    type: "Brand",
    progress:
      "32.5% Opened\n \n  57.0% Closed\n \n  26.3% Unsubscribe\n \n  65.8% Delivered\n \n  17.4% Conversation",
    members: "3+",
    startDate: "07 Nov 2023",
    endDate: "14 Nov 2023",
    status: "Bounced",
    created: "07 Nov 2023",
    Action: "Edit      Delete",
    key: "4",
  },
  {
    name: "Brand recognition",
    type: "Sales",
    progress:
      "72.6% Opened\n \n  53.5% Closed\n \n  16.5% Unsubscribe\n \n  83.0% Delivered\n \n  29.3% Conversation",
    members: "3+",
    startDate: "19 Nov 2023",
    endDate: "26 Nov 2023",
    status: "Running",
    created: "19 Nov 2023",
    Action: "Edit      Delete",
    key: "5",
  },
  {
    name: "Enhanced brand",
    type: "Media",
    progress:
      "56.3% Opened\n \n  20.5% Closed\n \n  30.5% Unsubscribe\n \n  70.5% Delivered\n \n  35.0% Conversation",
    members: "3+",
    startDate: "02 Dec 2023",
    endDate: "13 Dec 2023",
    status: "Paused",
    created: "02 Dec 2023",
    Action: "Edit      Delete",
    key: "6",
  },
  {
    name: "Repeat customers",
    type: "Rebranding",
    progress:
      "63.2% Opened\n \n  20.5% Closed\n \n  30.5% Unsubscribe\n \n  70.5% Delivered\n \n  87.8% Conversation",
    members: "3+",
    startDate: "17 Dec 2023",
    endDate: "27 Dec 2023",
    status: "Success",
    created: "17 Dec 2023",
    Action: "Edit      Delete",
    key: "7",
  },
  {
    name: "Competitor",
    type: "Product launch",
    progress:
      "40.5% Opened\n \n  52.7% Closed\n \n  13.5% Unsubscribe\n \n  70.5% Delivered\n \n  35.0% Conversation",
    members: "3+",
    startDate: "06 Jan 2024",
    endDate: "17 Jan 2024",
    status: "Paused",
    created: "06 Jan 2024",
    Action: "Edit      Delete",
    key: "8",
  },
];
